import { useCallback } from 'react'
import { Linking } from 'react-native'

// Don't use this because if the URL can't be opened, it fails silently!
export const useOpenUrl = () => {
  const openUrl = useCallback(async (url: string) => {
    const canOpen = await Linking.canOpenURL(url)

    if (!canOpen) {
      console.error(`Cannot open URL: ${url}`)
      // TODO show dialog to inform the user instead of failing silently!!!
      return
    }

    await Linking.openURL(url)
  }, [])

  return {
    openUrl,
  }
}
